import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-886aaae0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "installment-list"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardItem = _resolveComponent("CardItem")!

  return (_ctx.installmentDetails.installments.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.installmentDetails.installments, (installment) => {
            return (_openBlock(), _createElementBlock("li", {
              key: installment.amount
            }, [
              _createVNode(_component_CardItem, {
                title: _ctx.computeTermLabel(_ctx.t, _ctx.te, installment.term),
                "right-text": _ctx.computedAmountValue(installment.amount),
                "right-text-bold": true,
                onClick: ($event: any) => (_ctx.handleSelectInstallment(installment))
              }, null, 8, ["title", "right-text", "onClick"])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}